import { desktopCard } from "@ui/components/SheetSurface";
import { tv } from "@ui/lib/tv";

/**
 * Backdrop scrim. Silk fades it with travel progress; the class only sets the
 * fully-isOpen colour. M3 uses a lighter 32% scrim.
 */
export const dialogBackdrop = tv({
  base: "bg-black/40",
  variants: {
    platform: {
      ios: "",
      android: "bg-black/32",
      desktop: "",
    },
  },
});

/**
 * The Dialog skin. Mobile: a bottom card sheet sized to its content and capped
 * below the platform top inset (iOS 20px radius, M3 28px with a 640px tablet
 * cap). Desktop: the shared detached card.
 */
export const dialogPanel = tv({
  extend: desktopCard,
  variants: {
    platform: {
      ios: "max-h-[calc(var(--height-viewport)-max(env(safe-area-inset-top),30px)-10px)] rounded-t-[20px] bg-white shadow-sheet",
      // Capped and centred on tablet widths, per M3.
      android:
        "max-h-[calc(var(--height-viewport)-max(env(safe-area-inset-top),24px))] max-w-[640px] rounded-t-[28px] bg-white shadow-sheet",
      desktop: "",
    },
  },
  compoundVariants: [{ chrome: "bare", class: "bg-transparent shadow-none", platform: ["ios", "android"] }],
});
